import { Alert } from 'corso-admin-ui';
import { useShippingClaim } from '~/features/shippingClaimReview/ShippingClaimReviewProvider';
import { useShippingClaimAddTimelineEvent } from '~/features/shippingClaimReview/hooks/useShippingClaimAddTimelineEvent';
import { Timeline } from '~/features/timeline/Timeline';
import { useIsCorsoCxAgent } from '~/hooks/useIsCorsoAdmin';

export function ShippingClaimTimeline() {
  const shippingClaim = useShippingClaim();
  const { mutateAsync: addEvent, isPending } =
    useShippingClaimAddTimelineEvent();
  const isCorsoCxAgent = useIsCorsoCxAgent();

  if (!isCorsoCxAgent) return null;

  return (
    <Timeline
      alert={<Alert heading="Timeline is only visible to Corso users." />}
      events={shippingClaim.timeline ?? []}
      addEvent={addEvent}
      isPending={isPending}
      inputId="shipping-claim-timeline-comment"
    />
  );
}
